import React from 'react';
import { styled, SxProp } from 'dripsy';
import { observer } from 'mobx-react-lite';
import {
  EdgeInsets,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

import { FlatList, IFlatListProps } from '../common/FlatList';
import { Separator } from '../common/Separator';
import { Tutorial } from '@models/Tutorials/TutorialModel';
import { TimestampItem } from './TimestampItem';
import { TutorialTimestamp } from '@models/Tutorials/TutorialTimestampModel';

const List = styled<IFlatListProps<TutorialTimestamp>>(FlatList)({
  flex: 1,
});

function contentContainerStyle(props: EdgeInsets): SxProp {
  return (theme) => ({
    px: ['$6', '$7', '$0'],
    pb: theme.space.$6 + props.bottom,
  });
}

export interface ITimestampListProps
  extends Omit<
    IFlatListProps<TutorialTimestamp>,
    'data' | 'renderItem'
  > {
  tutorial: Tutorial;
  onPress(item: TutorialTimestamp): void;
}

export const TimestampList = observer<ITimestampListProps>(
  ({ tutorial, onPress, ...props }) => {
    const insets = useSafeAreaInsets();

    return (
      <List
        contentContainerSx={contentContainerStyle(insets)}
        data={tutorial.timestampsAsArray}
        renderItem={({ item }) => (
          <TimestampItem item={item} onPress={onPress} />
        )}
        keyExtractor={(_, i) => i.toString()}
        ItemSeparatorComponent={() => <Separator size="$5" />}
        {...props}
      />
    );
  },
);
